<template>
  <div>
    <Back />
    <div class="range" v-if="txt">
      <section class="range_section">
        
        <div class="intro range_intro">
          <h1>{{txt.range.title}}</h1>
          <h2>{{txt.range.subtitle}}</h2>
        </div>
        <full-price v-if="windowWidth > 980" :title="txt.range.fullprice.title" :lightBoxCopy="txt.range.fullprice.tooltip" :price="fullPrice" :currency="txt.range.fullprice.currency" :currency2="txt.range.fullprice.currency2" />
          
        <section class="saving-container">
          <div class="img-panel">
            <div class="img-left-container">
              <img  src="@/assets/img/car/leaf.png" alt="leaf car img" class="leaf-img">
              <price v-if="windowWidth <= 980" :title="txt.range.electricity.price.title" :lightBoxCopy="txt.range.electricity.price.tooltip" :price="fullPriceElectricity" :currency="txt.range.electricity.price.currency" :currency2="txt.range.electricity.price.currency2"/>
            </div>
            <div class="img-left-container">
              <img  src="@/assets/img/car/ice_car.png" alt="ice car img" class="ice_car-img">
              <price v-if="windowWidth <= 980" :title="txt.range.fuel.price.title" :lightBoxCopy="txt.range.fuel.price.tooltip" :price="fullPriceFuel" :currency="txt.range.fuel.price.currency" :currency2="txt.range.fuel.price.currency2"/>
            </div>
            <div class="icon-water-container" v-if="windowWidth > 980">
                <svg class="icon-water">
                  <use xlink:href="#icon-water" />
                </svg>
            </div>
            <div class="icon-flash-container" v-if="windowWidth > 980">
                <svg class="icon-flash">
                  <use xlink:href="#icon-flash" />
                </svg>
            </div>
          </div>
          
          <full-price v-if="windowWidth <= 980" :title="txt.range.fullprice.title" :lightBoxCopy="txt.range.fullprice.tooltip" :price="fullPrice" :currency="txt.range.fullprice.currency" :currency2="txt.range.fullprice.currency2" dtmTitle="specification-price-electricity" />

          <div class="intro toggle_multi-choice">
            <toggle
              v-if="mobileToggle.nav"
              :list="mobileToggle.nav"
              :active="0"
              labelDTM="Passengers"
              v-on:event_parent="eventNav"
            />
          </div>
          
          <div class="left-panel" v-if="mobileToggle.nav[0].active">
              <price v-if="windowWidth > 980" :title="txt.range.electricity.price.title" :lightBoxCopy="txt.range.electricity.price.tooltip" :price="fullPriceElectricity" :currency="txt.range.electricity.price.currency" :currency2="txt.range.electricity.price.currency2" dtmTitle="specification-price-cost"/>
              <multi-button
                v-if="mobileToggle.nav[0].active"
                :title="txt.range.electricity.model.title"
                :list="txt.range.electricity.model.list"
                :lightBoxCopy="txt.range.electricity.model.tooltip"
                :active="selectedModelElectricity"
                dtmTitle="specification-model-electricity"
                v-on:event_parent="eventElectricity"
              />
              <scale-buttons
                v-if="mobileToggle.nav[0].active"
                :title="txt.range.electricity.priceKwh.title"
                :active="priceElectricity"
                :lightBoxCopy="txt.range.electricity.priceKwh.tooltip"
                :default-value="Number(priceElectricity)"
                :range="txt.range.electricity.priceKwh.range"
                :step="Number(txt.range.electricity.priceKwh.step)"
                :SoM="txt.range.electricity.priceKwh.unitPerHour"
                :SoM2="txt.range.electricity.priceKwh.unitPerHour2"
                dtmTitle="specification-price-cost-electricity"
                v-on:event_qty="eventPriceElectricity"
              />
              <scale-buttons
                v-if="mobileToggle.nav[0].active"
                :title="txt.range.electricity.kwh.title"
                :active="KwhElectricity"
                :lightBoxCopy="txt.range.electricity.kwh.tooltip"
                :default-value="Number(KwhElectricity)"
                :range="txt.range.electricity.kwh.range"
                :step="Number(txt.range.electricity.kwh.step)"
                :SoM="txt.range.electricity.kwh.unitPerHour"
                :SoM2="txt.range.electricity.kwh.unitPerHour2"
                dtmTitle="specification-kwh-100km-cost-electricity"
                v-on:event_qty="eventKwhElectricity"

              />
               <info
                v-if=" mobileToggle.nav[0].active"
                :list="txt.listNav1"
              />
          </div>
          <div class="right-panel" v-if="mobileToggle.nav[1].active">
                <price v-if="windowWidth > 980" :title="txt.range.fuel.price.title" :lightBoxCopy="txt.range.fuel.price.tooltip" :price="fullPriceFuel" :currency="txt.range.fuel.price.currency" :currency2="txt.range.fuel.price.currency2" />
                <multi-button
                v-if="mobileToggle.nav[1].active"
                :title="txt.range.fuel.model.title"
                :list="txt.range.fuel.model.list"
                :lightBoxCopy="txt.range.fuel.model.tooltip"
                :active="selectedModelFuel"
                dtmTitle="specification-model-fuel"
                v-on:event_parent="eventFuel"
              />
                <scale-buttons
                  v-if="mobileToggle.nav[1].active"
                  :title="txt.range.fuel.kwh.title"
                  :lightBoxCopy="txt.range.fuel.kwh.tooltip"
                  :active="priceFuel"
                  :default-value="Number(priceFuel)"
                  :range="txt.range.fuel.kwh.range"
                  :step="Number(txt.range.fuel.kwh.step)"
                  :SoM="txt.range.fuel.kwh.unitPerHour"
                  :SoM2="txt.range.fuel.kwh.unitPerHour2"
                  dtmTitle="specification-cost-per-litre"
                  v-on:event_qty="eventPriceFuel"
                />
                <scale-buttons
                  v-if="mobileToggle.nav[1].active"
                  :title="txt.range.fuel.litre.title"
                  :lightBoxCopy="txt.range.fuel.litre.tooltip"
                  :active="priceFuelLitre"
                  :range="txt.range.fuel.litre.range"
                  :default-value="Number(priceFuelLitre)"
                  :step="Number(txt.range.fuel.litre.step)"
                  :SoM="txt.range.fuel.unitPerHour"
                  :SoM2="txt.range.fuel.unitPerHour2"
                  v-on:event_qty="eventPriceLitre"
                  dtmTitle="specification-l-100km"
                />
              <info
                v-if=" mobileToggle.nav[1].active"
                :list="txt.listNav2"
              />
          </div>
          <div class="bottom-panel" v-if="mobileToggle.nav[2].active">
            <input-range 
            v-if="windowWidth > 980"  
            :title="txt.range.kmperyear.title" 
            :lightBoxCopy="txt.range.kmperyear.tooltip" 
            v-on:event-range="eventKmYear" 
            :maxValue="txt.range.kmperyear.range.max"
            :default-value="kmYear"
            :SoM="txt.range.kmperyear.unitPerHour"
            dtmTitle="specification-miles-per-year"
            ></input-range>
            <scale-buttons
                v-if="windowWidth <= 980 && mobileToggle.nav[2].active"
                :title="txt.range.kmperyear.title"
                :lightBoxCopy="txt.range.kmperyear.tooltip"
                :default-value="Number(kmYear)"
                :active="kmYear"
                :range="txt.range.kmperyear.range"
                :step="Number(txt.range.kmperyear.step)"
                :SoM="txt.range.kmperyear.unitPerHour"
                v-on:event_qty="eventKmYear"
                dtmTitle="specification-miles-per-year"
              />
              <info
                v-if=" mobileToggle.nav[2].active"
                :list="txt.listNav3"
              />
          </div>
          
        </section>
        <finePrints v-if="disclaimer" :disclaimer="disclaimer" />
      </section>
    </div>
    <PageView v-if="dtm" pageName="vehicles|new|leaf|range-charging|estimatedautonomy" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import fullPrice from "@/components/Autonomy/fullPrice"
import Back from "@/components/shared/Buttons/Back";
import MultiButton from "@/components/shared/Buttons/MultiButton";
import SingleButton from "@/components/shared/Buttons/SingleButton";
import ScaleButtons from "@/components/shared/Buttons/ScaleButtons";
import InputRange from "@/components/shared/InputRange";
import Price from "@/components/shared/price";
import finePrints from "@/components/finePrints";
import PageView from "@/components/shared/DTM/PageView";
import FullPrice from '../components/Autonomy/fullPrice.vue';
import Toggle from "@/components/shared/Buttons/Toggle";
import HeatVsAcPopUp from "@/components/Autonomy/HeatVsAcPopUp";
import Info from "@/components/shared/Buttons/Info";

export default {
  name: "range",
  data() {
    return {
      windowWidth: 0,
      selectedModelFuel: 1,
      selectedModelElectricity: 1,
      priceElectricity: 0,
      KwhElectricity: 0,
      priceFuel: 0,
      priceFuelLitre: 0,
      kmYear: 0,
      mobileToggle: {
        nav: [
          {
            title: "",
            active: true,
            svg: "#icon-electric"
          },
          {
            title: "",
            active: false,
            svg: "#icon-fuel"
          },
          {
            title: "",
            active: false,
            svg: "#icon-miles"
          }
        ]
      },
    };
  },
  components: {
    Back,
    MultiButton,
    ScaleButtons,
    InputRange,
    Price,
    fullPrice,
    finePrints,
    Toggle,
    SingleButton,
    Info,
    PageView
  },
  computed: {
    ...mapState({
      txt: state => state.txt,
      
      country: state => state.country,
      range: state => state.range,
      dtm: state => state.dtm,
      disclaimer: state => state.txt.range.disclaimers,
    }),

    fullPriceElectricity(){
      const old = this.kmYear / 100
      const value = old * (this.priceElectricity *  this.KwhElectricity )
      const result = Math.round(value *100) / 100
      return result
    },
    fullPriceFuel(){
      if(this.country === 'uk') {
        const old = this.kmYear / 100
        const value = this.priceFuel * 4.54609  * this.kmYear * (1/this.priceFuelLitre)
        const result = Math.round(value *100) / 100
        return result

      } else{
        const old = this.kmYear / 100
        const value = old * (this.priceFuel * this.priceFuelLitre)
        const result = Math.round(value *100) / 100
        return result
      }
      
    },
    fullPrice() {
      const value = this.fullPriceFuel - this.fullPriceElectricity
      const result =  Math.round(value *100) / 100
      return result
    }
  },
  watch: {


    // the design is really different from mobile to desktop. To avoid components duplicate, I set some state depends of the screen size.
    windowWidth(newWidth) {
      if (newWidth <= 960) {
        return (
          (this.mobileToggle.nav[0].active = true),
          (this.mobileToggle.nav[1].active = false),
          (this.mobileToggle.nav[2].active = false)
        );
      }
      return (
        (this.mobileToggle.nav[0].active = true),
        (this.mobileToggle.nav[1].active = true),
        (this.mobileToggle.nav[2].active = true)
      );
    }
  },
  mounted() {

    this.kmYear = this.txt.range.kmperyear.range.default
    this.priceElectricity = this.txt.range.electricity.priceKwh.range.default
    this.KwhElectricity = this.txt.range.electricity.kwh.range.default
    this.priceFuel = this.txt.range.fuel.kwh.range.default
    this.priceFuelLitre = this.txt.range.fuel.litre.range.default
    this.mobileToggle.nav[0].title = this.txt.nav.title1
    this.mobileToggle.nav[1].title = this.txt.nav.title2
    this.mobileToggle.nav[2].title = this.txt.nav.title3
    
    // the design is really different from mobile to desktop. To avoid components duplicate, I set some state depends of the screen size.
    this.windowWidth = window.innerWidth;
    // set an event listener on screen resize
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  methods: {

    // START EVENTS
    eventFuel: function(val) {
      this.selectedModelFuel = val
      if(val === 2) {
        this.priceFuel = this.txt.range.fuel.kwh.range.default2
        this.priceFuelLitre = this.txt.range.fuel.litre.range.default2
      }
      else {
        this.priceFuel = this.txt.range.fuel.kwh.range.default
        this.priceFuelLitre = this.txt.range.fuel.litre.range.default
      }
      //this.$store.commit("SET_PASSENGERS", val);
    },
    eventElectricity: function(val) {
      if(val === 1) {
        this.KwhElectricity = this.txt.range.electricity.kwh.range.default
      }
      else {
        this.KwhElectricity = this.txt.range.electricity.kwh.range.default2
      }
      this.selectedModelElectricity = val
    },

    eventPriceElectricity: function(val) {
      this.priceElectricity = val
    },
    eventKwhElectricity: function(val) {
        if (window._satellite ) {
          console.log('aa')
      _satellite.track('generickCLicksTest', 'aaaaaaaa');
        }
      this.KwhElectricity = val
    },

    eventPriceFuel: function(val) {
      this.priceFuel = val
    },

    eventPriceLitre: function(val) {
      this.priceFuelLitre = val
    },

    eventKmYear: function(val) {
      this.kmYear = val
    },

    

    // Mobile Toggle
    eventNav: function(index) {
      // We get the index of the new active toggle
      // let's first check if the current active toggle is not the new one
      if (!this.mobileToggle.nav[index].active) {
        // if not, find the index of the current active toggle
        const findCurrentActive = this.mobileToggle.nav.findIndex(
          o => o.active === true
        );
        // set to false the current active toggle and switch the new one to true
        this.mobileToggle.nav[findCurrentActive].active = false;
        return (this.mobileToggle.nav[index].active = true);
      }
    }
    // END EVENTS
  }
};
</script>
